import React, { useState, useEffect } from "react";
import { Col, Row, InputGroup, InputGroupAddon, InputGroupText, Button } from "reactstrap";
import style from "./styles.module.scss";
import { DateFieldStyle, DateField } from "../../../utils";
import { Autosuggest } from "../..";
import GridPeopleInfo from "./GridRequestPeopleInfoFields";
import { debounce } from "../../../utils/Helper";

const initialFilter = {
  personId: null,
  personName: null,
  personType: null,
  fromDate: null,
  toDate: null,
};

const RequestPeopleInfoFields = ({
  fetchs,
  personToList,
  reportBCU,
  deletePersonFromList,
  fromDateReport,
  toDateReport,
  changeDateInfoRequest,
  error,
  searchperson,
  labelDate,
  disabled,
  dates,
}) => {
  const [filter, setFilter] = useState(initialFilter);

  useEffect(() => {
    setFilter({
      ...filter,
      fromDate: fromDateReport,
      toDate: toDateReport,
    });
  }, [fromDateReport, toDateReport]);

  const changeFilter = (name, value) => {
    if (name == "changePerson") {
      if (value.name == undefined) {
        setFilter({
          ...filter,
          personType: undefined,
          personName: value,
          personId: undefined,
        });
      } else {
        setFilter({
          ...filter,
          personId: value.id,
          personName: value.name,
          personType: value.type,
        });
      }
    } else {
      changeDateInfoRequest(name, value);
    }
  };

  const fetchSearch = ({ value }) => {
    return fetchs
      .SearchAllPeople({
        SdtPersonSearch: {
          text: value,
          personType: "",
          len: 10,
        },
      })
      .then((r) => r.SdtOutPersons.collection)
      .then((people) => {
        return people.map((s) => ({
          id: s.PersonId,
          name: `${s.PersonLegalName}`,
          type: s.PersonName,
        }));
      });
  };

  const onChangePerson = () => {
    personToList(filter);
  };

  const deletePerson = (personId) => {
    deletePersonFromList(personId);
  };

  return (
    <div>
      {dates && (
        <Row>
          <Col>
            <DateField
              label={labelDate ? "Trade Date From" : "From Date"}
              name="fromDate"
              onChange={(name, value) => changeFilter(name, value)}
              value={filter.fromDate}
              disabled={disabled}
            />
          </Col>
          <Col>
            <DateField
              label={labelDate ? "Trade Date To" : "To Date"}
              name="toDate"
              onChange={(name, value) => changeFilter(name, value)}
              value={filter.toDate}
              disabled={disabled}
            />
          </Col>
        </Row>
      )}

      {error && (
        <Row>
          <Col style={{ color: "red" }}>{error}</Col>
        </Row>
      )}
      {searchperson && (
        <Row>
          <Col md={10}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>

              <Autosuggest
                style={{ width: "80%" }}
                renderSuggestion={(suggestion) => (
                  <div className={style.suggestionItem}>
                    <strong>{` ${suggestion.name}`}</strong>
                  </div>
                )}
                getSuggestionValue={(s) => `${s.name}`}
                onSuggestionsFetchRequested={fetchSearch}
                value={filter.accountText || ""}
                inputProps={{
                  placeholder: "Person",
                }}
                fetchs={fetchs}
                onChange={(m, v) => {
                  changeFilter("changePerson", v);
                }}
              />
            </InputGroup>
          </Col>
          <Col md={2}>
            <Button className={style.buttonAlign} type="submit" onClick={() => onChangePerson()}>
              {"Add"}
            </Button>
          </Col>
        </Row>
      )}
      {searchperson && <GridPeopleInfo reportBCU={reportBCU} deletePerson={deletePerson} />}
    </div>
  );
};
export default RequestPeopleInfoFields;
